// Long/Short 노출·손익 계산 + 룰북 한도 (공유 유틸)

// 사이드별 북 사이즈(롱 80억 / 숏 80억). 종목별 비중 분모로 사용 —
// 실시간 합계는 시세 누락·드리프트로 흔들려서 고정값 사용. 북 리사이즈 시 여기만 수정.
export const SIDE_BOOK_KRW = 80e8;

export function getCurrentFxToKRW(currency, rates) {
  if (currency === "KRW") return 1;   // 원화는 KRW→KRW = 1 (기본 통화)
  if (currency === "USD") return rates.KRW || 1380;
  if (currency === "JPY") return (rates.KRW || 1380) / (rates.JPY || 149);
  if (currency === "HKD") return (rates.KRW || 1380) / (rates.HKD || 7.8);
  if (currency === "TWD") return (rates.KRW || 1380) / (rates.TWD || 31.5);
  return rates.KRW || 1380;
}

export const isShort = (h) => String(h.side || "Long").toLowerCase().startsWith("s");
export const sideMult = (h) => (isShort(h) ? -1 : 1);

// 종목 단위 지표 — 숏은 가격 하락 시 수익(P&L 부호 반전)
export function holdingMetrics(h, marketData, rates) {
  const md = marketData[h.ticker];
  const currency = md?.currency || h.currency || "USD";
  const fx = getCurrentFxToKRW(currency, rates);
  const bookFx = +h.avgExchangeRate > 0 ? +h.avgExchangeRate : fx;
  const hasPrice = md && md.price > 0;
  const price = hasPrice ? md.price : +h.avgCost;
  const qty = Math.abs(+h.quantity) || 0;          // 계약수(표시용, 단선도 그대로)
  const mult = String(h.notes || "").includes("단선") ? 10 : 1;   // 단일주식선물 계약승수 → 노미널 ×10
  const m = sideMult(h);
  const exposureKRW = price * qty * mult * fx;      // 절대 노출(그로스 기여, 노미널)
  const costKRW = +h.avgCost * qty * mult * bookFx;
  const pnlKRW = hasPrice ? m * (exposureKRW - costKRW) : 0;   // 숏: (장부-현재)
  const pnlPct = hasPrice && costKRW > 0 ? (pnlKRW / costKRW) * 100 : 0;
  const todayPnlKRW = md && md.change ? m * md.change * qty * mult * fx : 0;
  return {
    ...h, currency, fx, bookFx, hasPrice, price, qty,
    short: isShort(h), exposureKRW, costKRW, pnlKRW, pnlPct, todayPnlKRW,
    signedKRW: m * exposureKRW,
  };
}

export function portfolioExposure(holdings, marketData, exchangeRates) {
  const rates = { KRW: 1380, JPY: 149, TWD: 31.5, HKD: 7.8, ...exchangeRates };
  const rows = holdings.map((h) => holdingMetrics(h, marketData, rates));
  let longKRW = 0, shortKRW = 0, pnlKRW = 0, todayPnlKRW = 0;
  const bySector = {}, byMarket = {};
  for (const r of rows) {
    if (r.short) shortKRW += r.exposureKRW; else longKRW += r.exposureKRW;
    pnlKRW += r.pnlKRW; todayPnlKRW += r.todayPnlKRW;
    const sec = r.sector || r.market || "기타";
    bySector[sec] = (bySector[sec] || 0) + r.signedKRW;
    byMarket[r.market || "US"] = (byMarket[r.market || "US"] || 0) + r.signedKRW;
  }
  const grossKRW = longKRW + shortKRW;
  const netKRW = longKRW - shortKRW;
  return { rows, longKRW, shortKRW, grossKRW, netKRW, pnlKRW, todayPnlKRW, bySector, byMarket };
}

// 룰북 한도 (NAV 대비 %). warn=주의(🟡), max=초과(🔴)
export const LIMITS = {
  net:          { label: "순노출 Net",      target: "+20~30%", warn: 30,  max: 40,  signed: true },
  gross:        { label: "그로스 Gross",    target: "150~200%", warn: 250, max: 300 },
  single_long:  { label: "단일 롱 최대",    target: "≤8~10%",   warn: 8,   max: 10 },
  single_short: { label: "단일 숏 최대",    target: "≤4~5%",    warn: 4,   max: 5 },
  sector_net:   { label: "섹터 순노출 최대", target: "≤±15%",    warn: 12,  max: 15, signed: true },
};

export function statusOf(absPct, lim) {
  if (absPct > lim.max) return { icon: "🔴", color: "#c0392b", text: "초과" };
  if (absPct > lim.warn) return { icon: "🟡", color: "#b8860b", text: "주의" };
  return { icon: "🟢", color: "#0a7c59", text: "정상" };
}
